import React, { useState, useContext} from "react";
import { motion } from "framer-motion";
import { ImGithub } from "react-icons/im";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { GlobalContext } from "../context/Store";
const SingleProject = ({ projectTitle, projectDescription, githubLink, images, animateDelay, }) => {
  const [showAlbum, setShowAlbum] = useState(false);
  const [selectedImageIndex, setselectedImageIndex] = useState(0);
    // ✅ States / Variables ------------------------------------------------------------------------------------------------------------
    const { imgAnimationCustom } = useContext(GlobalContext);

  const handleShowAlbum = () => {
    setShowAlbum(true);
    document.body.style.overflow = "hidden"; // disable scrolling on body
  };

  const handleCloseAlbum = () => {
    setShowAlbum(false);
    setselectedImageIndex(0);
    document.body.style.overflow = "auto"; // enable scrolling on body
  };

  const handlePrevImage = () => {
    setselectedImageIndex((prevIndex) => {
      if (prevIndex === 0) {
        return images.length - 1;
      } else {
        return prevIndex - 1;
      }
    });
  };

  const handleNextImage = () => {
    setselectedImageIndex((prevIndex) => {
      if (prevIndex === images.length - 1) {
        return 0;
      } else {
        return prevIndex + 1;
      }
    });
  };
  const handleImageClick = (image) => {
    window.open(image, "_blank", "noopener noreferrer");
  };
  
  // const handleImageClick = (image) => {
  //   window.open(image, "_blank");
  // };

  const handleAlbumImageClick = (index) => {
    setselectedImageIndex(index);
  };

  return (
    <>
      <motion.div
        {...imgAnimationCustom(0.3, animateDelay)}
        className="single_project flex h-auto w-72 flex-col gap-3 rounded-lg border-2 border-gray-200 p-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
      >
        <img
          className="h-40 rounded-lg object-cover brightness-95 transition-all duration-300 hover:brightness-100 cursor-pointer"
          src={images[0]}
          alt="Project"
          onClick={() => handleImageClick(images[0])}
        />

        <p className="font-open-sans-font text-xl font-semibold">
          {projectTitle?.length > 19 ? `${projectTitle.slice(0, 19)}...` : `${projectTitle}.`}
        </p>
        <p className="font-open-sans-font text-base font-medium">
          {projectDescription?.length > 55
            ? `${projectDescription.slice(0, 55)}...`
            : `${projectDescription}.`}
        </p>
        <div className="project_links mt-3 flex gap-4">
          <a
            rel="noopener"
            className={`${!githubLink && "hover:cursor-not-allowed"}`}
            href={githubLink}
            target="_blank"
          >
            <div className="flex h-9 w-11 items-center justify-center rounded-sm bg-[#222222] shadow-2xl shadow-black transition-all duration-200 hover:-translate-y-[2px]">
              <ImGithub className="text-lg text-white" />
            </div>
          </a>

          {images && (
            <button
              onClick={handleShowAlbum}
              className="animate_button_main flex h-9 items-center justify-center rounded-md bg-tertiary-color px-5 font-rubik-font font-semibold text-black shadow-lg shadow-gray-200 hover:border hover:border-secondary-color"
            >
              Demo
            </button>
          )}
        </div>
      </motion.div>
{showAlbum && (
        <div className="fixed top-0 left-0 right-0 bottom-0" style={{ zIndex: 100 }}>
          <div className="fixed top-10 left-13 right-10 bottom-0 overflow-auto bg-white flex flex-wrap justify-center">
            <button
              onClick={handleCloseAlbum}
              className="fixed top-10 left-5 bg-white text-black px-3 py-1 rounded-lg shadow-md font-rubik-font font-medium hover:bg-gray-100"
            >
              <FaArrowLeft className="inline-block mr-1" />
              Back
            </button>

            {selectedImageIndex !== null && (
              <img
                className="max-h-full max-w-full cursor-pointer"
                src={images[selectedImageIndex]}
                alt="Selected Project"
                onClick={() => handleImageClick(images[selectedImageIndex])}
              />
            )}

            {images.map((img, index) => (
              <img
                key={index}
                className={`album-thumbnail w-${
                  images.length <= 5 ? "1/3" : "1/4"
                } h-auto cursor-pointer ${
                  selectedImageIndex === index ? "border-2 border-gray-200 rounded-lg" : ""
                }`}
                src={img}
                alt="Project"
                onClick={() => handleAlbumImageClick(index)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SingleProject;
